// extracted by mini-css-extract-plugin
export default {"title-list":"title-list__NX49G","title-list__header":"title-list__header__U1+rn","title-list__title":"title-list__title__bFJph"};